import { LOT_RELEASE_ROWS } from "../controleConstants";
import { CHARTER_THEME } from "../controleTheme";
import { documentCardStyle, lotReleaseBodyCellStyle, lotReleaseHeaderCellStyle } from "../styles/reportStyles";

export function LotReleaseReport({ activeDossier, selectedEhpad, meta, value, onChange }) {
    const { inputStyle } = CHARTER_THEME;
    const data = value || {};

    const updateField = (key, nextValue) => {
        onChange({ ...data, [key]: nextValue });
    };

    const updateRow = (key, patch) => {
        onChange({
            ...data,
            rows: {
                ...(data.rows || {}),
                [key]: {
                    ...((data.rows || {})[key] || {}),
                    ...patch,
                },
            },
        });
    };

    return (
        <div style={documentCardStyle}>
            <div style={{ display: "grid", gridTemplateColumns: "minmax(180px, 1fr) minmax(260px, 1.2fr) minmax(120px, 0.5fr)", gap: "12px", alignItems: "center" }}>
                <input
                    style={{ ...inputStyle, width: "100%", fontWeight: 900, fontSize: "15px" }}
                    value={data.pharmacien || meta.pharmacien || ""}
                    onChange={event => updateField("pharmacien", event.target.value)}
                    placeholder="Pharmacien"
                />
                <input
                    style={{ ...inputStyle, width: "100%", textAlign: "center", fontWeight: 900, fontSize: "15px" }}
                    value={data.numeroLot || `NUMÉRO DE LOT ${activeDossier?.numeroLot || ""}`}
                    onChange={event => updateField("numeroLot", event.target.value)}
                    placeholder="Numéro de lot"
                />
                <div style={{ justifySelf: "end", color: "#0369a1", fontWeight: 900, fontSize: "13px" }}>neopharm</div>
            </div>

            <div style={{ overflowX: "auto", border: "1px solid #cbd5e1", borderRadius: "8px", background: "white" }}>
                <table style={{ width: "100%", minWidth: "820px", borderCollapse: "collapse" }}>
                    <thead>
                        <tr style={{ background: "#f8fafc" }}>
                            <th style={lotReleaseHeaderCellStyle}>POINT DE CONTRÔLE</th>
                            <th style={{ ...lotReleaseHeaderCellStyle, width: "190px" }}>CONFORME (O/N)</th>
                            <th style={{ ...lotReleaseHeaderCellStyle, width: "190px" }}>VISA</th>
                        </tr>
                    </thead>
                    <tbody>
                        {LOT_RELEASE_ROWS.map(([key, label], index) => {
                            const row = (data.rows || {})[key] || {};
                            const defaultPoint = key === "nomEhpad"
                                ? selectedEhpad?.nom || activeDossier?.ehpadNom || label
                                : key === "nombreSachet"
                                    ? meta.nombreSachetsProduits || label
                                    : label;
                            return (
                                <tr key={key}>
                                    <td style={{ ...lotReleaseBodyCellStyle, minHeight: index === 0 ? "110px" : undefined }}>
                                        <textarea
                                            style={{ ...inputStyle, width: "100%", minHeight: index === 0 ? "110px" : "48px", resize: "vertical", lineHeight: 1.45, fontWeight: 800 }}
                                            value={row.point ?? defaultPoint}
                                            onChange={event => updateRow(key, { point: event.target.value })}
                                        />
                                    </td>
                                    <td style={lotReleaseBodyCellStyle}>
                                        <select
                                            style={{ ...inputStyle, width: "100%" }}
                                            value={row.conforme || ""}
                                            onChange={event => updateRow(key, { conforme: event.target.value })}
                                        >
                                            <option value="">—</option>
                                            <option value="O">O</option>
                                            <option value="N">N</option>
                                        </select>
                                    </td>
                                    <td style={lotReleaseBodyCellStyle}>
                                        <input
                                            style={{ ...inputStyle, width: "100%" }}
                                            value={row.visa || ""}
                                            onChange={event => updateRow(key, { visa: event.target.value })}
                                            placeholder="Visa"
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
